var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.to}},[_c('div',{staticClass:"card"},[_c('img',{attrs:{"src":_vm.image,"alt":"service"}}),_c('div',{staticClass:"overlay"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('div',{staticClass:"edge"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }